export default {
  title: 'Dynamik der Immobilienverkäufe',
  x_axis: 'Datum',
  y_axis: 'Anzahl der Verkäufe',
  districts: {
    alanya: 'Alanya',
    konyaalti: 'Konyaaltı',
    kemer: 'Kemer',
    kepez: 'Kepez',
    dosemealti: 'Döşemealtı',
    finike: 'Finike'
  }
}
